// @flow strict
import React from "react";
import { withPrefix, Link } from "gatsby";
import styles from "./Copyright.module.scss";

type Props = {
  copyright: string
};

const Copyright = ({ copyright }: Props) => (
  <div className={styles["copyright"]}>
    <a
      target="_blank"
      title={copyright}
      href="https://creativecommons.org/licenses/by-sa/4.0/"
    >
      <img
        className={styles["copyright"]}
        alt={copyright}
        src={withPrefix("./CC-BY-SA.svg")}
      />
    </a>

    <a
      target="_blank"
      title="Gatsby JS"
      href="https://www.gatsbyjs.org/"
    >

      <img className={styles["copyright"]} alt="Create with Gatsby v2" src="https://img.shields.io/badge/Built%20in-Berlin-critical.svg?logo=gatsby"></img>

    </a>
  </div>
);

export default Copyright;
